// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


import { makeDefaultFailedContainer } from 'components/container'

const WhoAmI = React.createClass({
  render() {
    const { me } = this.props
    return (
      <div>
        <h1>
          You are
        </h1>
        <pre>
          {JSON.stringify(me, null, "\t")}
        </pre>
      </div>
    )
  }
})

export default makeDefaultFailedContainer(WhoAmI, {
  listenTo: ['stores.UserStore'],
  fetch: {
    me() {
      return this.app.stores.UserStore.getOrFetchCurrentUser()
    }
  }
})



// WEBPACK FOOTER //
// ./src/scripts/components/WhoAmI.js